import React from 'react';
import { Hero, Testimonials, Problem } from './components/Sections1';
import { Product, Bonuses } from './components/Sections2';
import { Pricing } from './components/Sections3';
import { Guarantee, FAQ, CostOfInaction, Footer } from './components/Sections4';
import { useMetaPixel } from './components/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-brand-500/30" data-id="element-0" data-mp="3f8nedijx7b8k">
      <main data-id="element-1" data-mp="2rit2p4bc7spw">
        <Hero data-id="element-2" data-mp="2mlu8ymvl5ns8" />
        <Testimonials data-id="element-3" data-mp="2mm2n0i3g2z50" />
        <Problem data-id="element-4" data-mp="2mmvlkvs92ic2" />
        <Product data-id="element-5" data-mp="2mndp8dh8ryu0" />
        <Bonuses data-id="element-6" data-mp="2mjpvpebsrcfa" />
        <Pricing data-id="element-7" data-mp="31aqdi9yfoio3" />
        <Guarantee data-id="element-8" data-mp="31b8ka0iq2fa9" />
        <FAQ data-id="element-9" data-mp="31bs11dwmyxmp" />
        <CostOfInaction data-id="element-10" data-mp="31c9vc4zqn1rz" />
      </main>
      <Footer data-id="element-11" data-mp="31cjk5p91r2w3" />
    </div>;
}